var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSortingUp16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.85L7.39571 9.2155L5.42857 11.2765V4H4.57143V11.2765L2.60429 9.211L2 9.85L5 13L8 9.85Z",
    fill: "#C2C3C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6.15L13.3957 6.7845L11.4286 4.7235V12H10.5714V4.7235L8.60429 6.789L8 6.15L11 3L14 6.15Z",
    fill: "#6D747D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortingUp16);
export default __webpack_public_path__ + "static/media/SortingUp16.cc0e019200f47d7a35611f9c96ed1837.svg";
export { ForwardRef as ReactComponent };